import { render, staticRenderFns } from "./BtnLgDefault.vue?vue&type=template&id=7ccfd9ce&scoped=true"
import script from "./BtnLgDefault.vue?vue&type=script&lang=js"
export * from "./BtnLgDefault.vue?vue&type=script&lang=js"
import style0 from "./BtnLgDefault.vue?vue&type=style&index=0&id=7ccfd9ce&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccfd9ce",
  null
  
)

export default component.exports